module.exports = __webpack_public_path__ + "media/font/iconfont-b7feab36.eot";